import getDistinctSlices from './getDistinctSlices';
import { getSlotMetrics } from '@teetsh/app/src/components/EDT/rbc/TimeSlots';
import noOverlap from '@teetsh/app/src/components/EDT/rbc/no-overlap';
import { getEventsHappeningDuringTheSlice } from '@teetsh/app/src/utils/slices';
import _groupBy from 'lodash-es/groupBy';
import getDay from '@teetsh/app/src/utils/time/getDay';
import _minBy from 'lodash-es/minBy';
import endOfDay from '@teetsh/app/src/utils/time/endOfDay';
import _maxBy from 'lodash-es/maxBy';
import _uniq from 'lodash-es/uniq';
import _union from 'lodash-es/union';
import { findLCM } from '@teetsh/app/src/utils/lcm';
import { RbcComputedEvent } from './types';

export function computeLCMForEvts(events) {
  const slices = getDistinctSlices(events);
  const allLength = slices.reduce((acc, num) => {
    const { allEvents } = getEventsHappeningDuringTheSlice(events, num);
    const eventsByDay = _groupBy(allEvents, e => getDay(e.start));
    const result = Object.values(eventsByDay).reduce<number[]>(
      (accc, eventsOfTheDay) => {
        const eventsByClassroom = _groupBy(eventsOfTheDay, e =>
          e.classroomIds.join('%%'),
        );
        const len = Object.values(eventsByClassroom).map(evs => {
          const rbcComputedEvents: RbcComputedEvent[] =
            evs.length > 0
              ? noOverlap({
                  events: evs,
                  minimumStartDifference: 0,
                  slotMetrics: getSlotMetrics({
                    min: _minBy(evs, e => e.start)?.start,
                    max: endOfDay(_maxBy(evs, e => e.end)?.end as Date),
                    step: 1,
                    timeslots: 200,
                  }),
                  accessors: {
                    start: e => e.start,
                    end: e => e.end,
                  },
                }).map(e => ({
                  event: e.event,
                  leftInPixels: e.style.left,
                  widthInPixels: e.style.width,
                }))
              : [];
          const uniqX = _uniq(rbcComputedEvents.map(e => e.leftInPixels));
          return uniqX.length;
        });
        return _union(accc, len);
      },
      [],
    );
    return _union(acc, result);
  }, []);
  return findLCM(allLength);
}
